export default "<p>dashboard works!</p>\n"